import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { ThemeProvider } from './main/contexts/ThemeContext';
import { LanguageProvider } from './main/contexts/LanguageContext';
import { useGlobalBuilder } from './archbuilder/GlobalBuilder';

const Root = () => {
  useGlobalBuilder();
  return (
    <React.StrictMode>
      <LanguageProvider>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </LanguageProvider>
    </React.StrictMode>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(<Root />);
